import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInvoiceById,
  fetchCreditNoteById,
  fetchReceiptById,
  fetchTallyData,
  syncInvoiceWithTally,
  syncCreditNoteWithTally,
  syncReceiptWithTally,
  createTallyCustomerLedger,
} from "./tally.async";

const initialState = {
  invoice: null,
  tallyData: null,
  loading: false,
  error: null,
  tallyError: null,
  success: false,
};

// Helper to generate sync reducers
const addSyncCases = (builder, action, fallbackError) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.tallyError = null;
      state.success = false;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading = false;
      const success = action.payload?.success === true;
      state.success = success;
      state.tallyError = success ? null : action.payload?.tallyError || null;
      state.error = success
        ? null
        : action.payload?.message || `${action.payload?.message || ""} \n${
            action.payload?.tallyError || ""
          }`;
    })
    .addCase(action.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.tallyError = action.payload?.tallyError || null;
      state.error = action.payload || action.error?.message || fallbackError;
    });
};

const tallySlice = createSlice({
  name: "tally",
  initialState,
  reducers: {
    resetTallyState: (state) => {
      state.invoice = null;
      state.tallyData = null;
      state.loading = false;
      state.error = null;
      state.tallyError = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch actions
    builder
      .addCase(fetchInvoiceById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoiceById.fulfilled, (state, action) => {
        state.loading = false;
        state.invoice = action.payload;
      })
      .addCase(fetchInvoiceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCreditNoteById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreditNoteById.fulfilled, (state, action) => {
        state.loading = false;
        state.invoice = action.payload;
      })
      .addCase(fetchCreditNoteById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchReceiptById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReceiptById.fulfilled, (state, action) => {
        state.loading = false;
        state.invoice = action.payload;
      })
      .addCase(fetchReceiptById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTallyData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTallyData.fulfilled, (state, action) => {
        state.loading = false;
        state.tallyData = action.payload;
      })
      .addCase(fetchTallyData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Sync actions using helper
    addSyncCases(builder, createTallyCustomerLedger, "Create Tally Ledger failed!");
    addSyncCases(builder, syncInvoiceWithTally, "Invoice sync failed!");
    addSyncCases(builder, syncCreditNoteWithTally, "Credit Note sync failed!");
    addSyncCases(builder, syncReceiptWithTally, "Receipt sync failed!");
  },
});

export const { resetTallyState } = tallySlice.actions;
export default tallySlice.reducer;